import React, {
  useCallback, useRef, memo, useState, useMemo,
} from 'react'
import { error as showError } from '@active/react-ui/FloatAlert'
import Button from '@active/react-ui/Button'
import { withI18n } from '@active/react-utils/i18n'
import isEmpty from 'lodash/isEmpty'
import DefaultComponentLayout, { LayoutContent } from '../common/Layout'
import I18nMessage from '../common/I18nMessage'
import ShippingAddress from './ShippingAddress'
import './ShippingManagement.scss'

function ShippingManagement({
  i18n,
  epid,
  widgetToken,
  hasWidgetToken,
  ...rest
}) {
  const submitRef = useRef()
  const [saving, setSaving] = useState(false)
  const handleError = useCallback(error => {
    if (!isEmpty(error) && (error[0]?.message || error.message)) {
      showError({ timeout: 4000, message: error[0]?.message || error.message, theme: 'inline' })
    } else {
      showError({ timeout: 4000, message: i18n('passport.error.server.default'), theme: 'inline' })
    }
  }, [i18n])

  const handleUserActionError = useCallback(() => {
    showError({ timeout: 4000, message: i18n('passport.error.server.default'), theme: 'inline' })
  }, [i18n])

  const submitTrigger = useCallback(fn => {
    submitRef.current = fn
  }, [submitRef])

  const handleClickBtn = useCallback(async () => {
    setSaving(true)
    await submitRef.current()
    setSaving(false)
  }, [submitRef])

  const errMsg = useMemo(() => {
    if (!hasWidgetToken) return 'passport.error.server.default'
    return undefined
  }, [hasWidgetToken])

  return (
    <DefaultComponentLayout errMsg={errMsg} nameSpace="passport-shipping-address">
      {!errMsg && epid && <LayoutContent title message="passport.shippingAddress.title" />}
      {
        !errMsg && epid && (
        <LayoutContent main>
          <ShippingAddress
            {...rest}
            epid={epid}
            handleError={handleError}
            handleUserActionError={handleUserActionError}
            triggers={{ submitTrigger }}
          />
        </LayoutContent>
        )
      }
      {
        !errMsg && epid && (
        <LayoutContent footer>
          <Button
            type="primary"
            disabled={saving}
            className="passport-shipping-address__btn"
            onClick={handleClickBtn}
          >
            <I18nMessage id="passport.common.btn.save" />
          </Button>
        </LayoutContent>
        )
      }
    </DefaultComponentLayout>
  )
}

export default memo(withI18n(ShippingManagement))
